module.exports = __webpack_public_path__ + "static/media/Ezugi5.33b53a81.webp";